
//export const baseApiUrl = 'https://localhost:44394/api';

export const baseApiUrl = 'https://cadastrofranqueado.liz.com.br/api'